<template>
  <div class="header">
    <el-row>
      <el-col :span="4">
        <div class="logoContainer">
          <div class="logoImg" style="height: 100px">
            <!-- 1.链接到首页
        2.名称使用好看的字符 -->
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img
                src="./assets/img/brain.png"
                alt=""
                width="95px"
                height="95px"
              />
            </a>
          </div>
          <div class="webName">
            <span>Brain<br />Cell type<br />Database</span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <searchBox :show="show" />
      </el-col>
      <el-col :span="11">
        <menuBox />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import searchBox from './components/serachBox'
import menuBox from './components/menuBox'
export default {
  components: {
    searchBox,
    menuBox
  },
  name: 'Header',
  data () {
    return {}
  }
}
</script>

<style scoped lang="less">
@font-face {
  font-family: "webNameFont";
  font-display: swap;
  src: url("./assets/font/webName/webfont.eot"); /* IE9 */
  src: url("./assets/font/webName/webfont.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-IE8 */ url("./assets/font/webName/webfont.woff2") format("woff2"),
    url("./assets/font/webName/webfont.woff") format("woff"),
    /* chrome、firefox */ url("./assets/font/webName/webfont.ttf")
      format("truetype"),
    /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
      url("./assets/font/webName/webfont.svg#webfont") format("svg"); /* iOS 4.1- */
}
.header {
  height: 100px;
  max-width: 1180px;
  margin: 0 auto;
}
.logoContainer {
  overflow: hidden;
  .logoImg {
    float: left;
  }
  .webName {
    float: left;
    // font-family: "webNameFont";
    font-size: 15px;
    font-weight: bolder;
    height: 75px;
    line-height: 25px;
    margin-top: 12px;
    //border-left: 1px solid #2c3e50 ;
    padding-left: 6px;
    box-shadow: -1px 0 #adcceb;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Header/index.vue